function checkLenghtWords(words, cutIn) {
    if (words.length > cutIn) {
        return words.substr(0, cutIn - 4) + "...";
    }
    return words;
}
function formatNumber(number) {
    return new Intl.NumberFormat().format(number);
}

export { checkLenghtWords as c, formatNumber as f };
